import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import "../styles/SKUDetails.css";
import axios from 'axios';
import { GridLoader } from 'react-spinners';

function SKUDetails() {
  const navigate = useNavigate();
  const { state } = useLocation();

  const [licenses, setLicenses] = useState({});
  const [productImage, setProductImage] = useState(null);
  const [gtin, setGtin] = useState("");
  const [genericName, setGenericName] = useState("");
  const [license, setLicense] = useState("");
  const [manufacturingLic, setManufacturingLic] = useState("");
  const [groupId, setGroupId] = useState(JSON.stringify({}));
  const [excipients, setExcipients] = useState("");
  const [visitUsUrl, setVisitUsUrl] = useState("");
  const [fieldErrors, setFieldErrors] = useState({});
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [groupIds, setGroupIds] = useState([]);
  const [alertMessage, setAlertMessage] = useState(false);
  const [createdLicenses, setCreatedLicenses] = useState([]);
  const [showNoUnitsMessage, setShowNoUnitsMessage] = useState(false);

  const baseURL = sessionStorage.getItem('baseURL');

  useEffect(()=>{
    console.log(JSON.parse(groupId))
  }, [groupId])

  useEffect(() => {
    if (sessionStorage.getItem('isLoggedIn') !== "true") {
      navigate('/');
      return;
    } else if (sessionStorage.getItem('isAdmin') !== "true") {
      navigate('/#/dashboard');
      return;
    }

    setLicenses(JSON.parse(sessionStorage.getItem('licenses')));
    const lics = JSON.parse(sessionStorage.getItem('licenses')) || [];
    setCreatedLicenses(lics.map(item => ({
      lic_no: item.lic_no,
      name: item.name,
      sku_id: item.sku_id,
    })));
    fetchDetails();
    document.getElementById('loading').hidden = true;
  }, [navigate]);

  const handleImageUpload = (e) => setProductImage(e.target.files[0]);

  const fetchDetails = async () => {
    try {
      document.getElementById("loading").hidden = false;
      const response = await axios.get(baseURL + "pu/getGroupIds");
      const units = response.data.map(u => ({"name": u.production_unit_name, "addr": u.address}));
      setGroupIds(units);
      if (units.length === 0) setShowNoUnitsMessage(true);
    } catch (error) {
      console.error("Error fetching group IDs:", error);
      setGroupIds([]);
    } finally {
      document.getElementById("loading").hidden = true;
    }
  };

  function showToast(message, type = "success") {
    const toast = document.createElement("div");
    toast.innerText = message;
    const bg =
      type === "error" ? "#C0392B" :
        type === "warning" ? "#e67e22" :
          "#1a6b3c";
    Object.assign(toast.style, {
      position: "fixed", top: "20px", right: "20px",
      background: bg, color: "#fff",
      padding: "12px 20px", borderRadius: "8px",
      boxShadow: "0 6px 20px rgba(0,0,0,0.18)",
      zIndex: 9999, opacity: "0",
      fontSize: "0.92rem",
      fontFamily: "'Source Sans 3', system-ui, sans-serif",
      fontWeight: "600", letterSpacing: "0.01em",
      transition: "opacity 0.3s ease",
    });
    document.body.appendChild(toast);
    requestAnimationFrame(() => (toast.style.opacity = "1"));
    setTimeout(() => {
      toast.style.opacity = "0";
      setTimeout(() => toast.remove(), 300);
    }, 3500);
  }

  const SubmitDetails = () => {
    document.getElementById('loading').hidden = false;
    setAlertMessage(false);
    const newQrData = new FormData();
    newQrData.append("productImage", productImage);
    newQrData.append("gtin", gtin);
    newQrData.append("genericName", genericName);
    newQrData.append("brand", selectedProduct.sku_name);
    newQrData.append("license", manufacturingLic);
    newQrData.append("lic_no", license);
    newQrData.append("group_id", groupId);
    newQrData.append("excipients", excipients);
    newQrData.append("visitUsUrl", visitUsUrl);
    newQrData.append("licenseDetails", JSON.stringify(selectedProduct));
    newQrData.append("qr_types", JSON.stringify(selectedProduct.qr_types));

    try {
      axios.post(baseURL + 'sku/SKUDetailsAdd', newQrData, {
        headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` }
      }).then(() => {
        showToast("SKU Data Added Successfully");
        document.getElementById('loading').hidden = true;
        setProductImage(null);
        setGtin("");
        setGenericName("");
        setLicense("");
        navigate('/dashboard');
      }).catch(() => {
        showToast("Error Adding SKU Data. Please try again.", "error");
      });
    } catch (error) {
      console.error(error);
    }
  };

  const checkLicense = () => {
    const lic = license.trim();
    const isCreated = Array.isArray(createdLicenses) &&
      createdLicenses.some(item => item.lic_no === lic);

    if (isCreated) {
      setSelectedProduct(null);
      setFieldErrors(prev => ({ ...prev, license: "SKU for this License No. is already created." }));
    } else {
      axios.get(baseURL + `license/validateLicense/${license}`, {
        headers: { Authorization: `Bearer ${sessionStorage.getItem('token')}` }
      }).then(response => {
        if (response.data.license !== 'License Not Found') {
          setFieldErrors({});
          setSelectedProduct(response.data.license);
        } else {
          setSelectedProduct(null);
          setFieldErrors(prev => ({ ...prev, license: "License No. is invalid. Please check." }));
        }
      }).catch(() => {
        setFieldErrors(prev => ({ ...prev, license: "Error validating license. Please try again." }));
      });
    }
  };

  const handleGtinChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      setGtin(value);
      setFieldErrors(prev => ({ ...prev, gtin: "" }));
    }
  };

  const handleGenericName = (e) =>{
    const value = e.target.value;
    setGenericName(value);
    setFieldErrors(prev => ({ ...prev, genericName: "" }));
  }

  const handleManufacturingLicChange = (e) => {
    const value = e.target.value;
    setManufacturingLic(value);
    setFieldErrors(prev => ({ ...prev, manufacturingLic: "" }));
  };

  const handleExcipientsChange = (e) => {
    const value = e.target.value;
    setExcipients(value);
    setFieldErrors(prev => ({ ...prev, excipients: "" }));
  };

  const handleVisitUsUrlChange = (e) => {
    const value = e.target.value;
    setVisitUsUrl(value);
    setFieldErrors(prev => ({ ...prev, visitUsUrl: "" }));
  };

  const handleAddSKU = () => {
    const licErr = fieldErrors.license;
    setFieldErrors({});
    const errors = {};
    if (licErr) errors.license = licErr;
    if (license.trim() === "") errors.license = "License No. is required.";
    if (!productImage) {
      errors.productImage = "Product Image is required.";
    } else {
      if (!["image/png", "image/jpeg"].includes(productImage.type))
        errors.productImage = "Only PNG and JPEG images are allowed.";
      if (productImage.size > 250 * 1024)
        errors.productImage = "File size must be less than 250KB.";
    }
    if (!gtin.trim()) errors.gtin = "GTIN is required.";
    else if (gtin.length !== 14) errors.gtin = "GTIN must be 14 digits.";
    if (!genericName.trim()) errors.genericName = "Generic Name is required.";
    if (!manufacturingLic.trim()) errors.manufacturingLic = "Manufacturing License is required.";
    if (manufacturingLic.trim() && !/^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9/-]+$/.test(manufacturingLic.trim()))
      errors.manufacturingLic = "Manufacturing License must be alphanumeric and may include '/' or '-'.";
    if (!excipients.trim()) errors.excipients = "Excipients are required.";
    if (!visitUsUrl.trim()) errors.visitUsUrl = "Visit Us URL is required.";
    if (Object.keys(errors).length > 0) { setFieldErrors(errors); return; }
    setAlertMessage(true);
  };

  /* ── Confirmation modal styles (Cadila tokens, no inline gradients) ── */
  const modalOverlayStyle = {
    position: 'fixed', inset: 0,
    background: 'rgba(35, 40, 45, 0.5)',
    zIndex: 9999,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    backdropFilter: 'blur(2px)',
  };
  const modalBoxStyle = {
    background: '#fff',
    borderRadius: '12px',
    width: '460px',
    maxWidth: '92vw',
    border: '1px solid #E2E6F3',
    boxShadow: '0 12px 40px rgba(44, 52, 147, 0.18)',
    overflow: 'hidden',
    animation: 'modal-in .22s cubic-bezier(.4,0,.2,1)',
  };
  const modalHeaderStyle = {
    background: '#2C3493',
    color: '#fff',
    padding: '20px 24px',
  };
  const modalBodyStyle = { padding: '24px' };
  const warnBlockStyle = {
    background: '#fffbeb',
    border: '1px solid #fde68a',
    borderLeft: '3px solid #b45309',
    borderRadius: '0 7px 7px 0',
    padding: '13px 15px',
    marginBottom: '16px',
  };
  const ackBlockStyle = {
    background: '#eef0fa',
    borderRadius: '7px',
    padding: '12px 14px',
    fontSize: '13px',
    color: '#23282D',
    lineHeight: '1.6',
  };
  const modalFooterStyle = {
    display: 'flex', gap: '10px',
    padding: '0 24px 24px',
  };
  const btnBackStyle = {
    flex: 1, padding: '11px',
    background: '#fff',
    border: '1.5px solid #E2E6F3',
    borderRadius: '7px', cursor: 'pointer',
    fontSize: '14px',
    fontFamily: "'Source Sans 3', system-ui, sans-serif",
    fontWeight: '600', color: '#8A90A8',
    transition: 'border-color .22s',
  };
  const btnConfirmStyle = {
    flex: 2, padding: '11px',
    background: '#2C3493',
    color: '#fff', border: 'none',
    borderRadius: '7px', cursor: 'pointer',
    fontSize: '14px',
    fontFamily: "'Source Sans 3', system-ui, sans-serif",
    fontWeight: '600',
    transition: 'filter .22s',
  };

  return (
    <div className="SKUDetails">

      {/* ── Header ── */}
      <div className="dashboard-header">
        <button onClick={() => navigate('/dashboard')} className="action-button">← Back</button>
      </div>

      {/* ── Form ── */}
      {!showNoUnitsMessage && (
        <div className="generate-qr-container">
          <div className="info-table">
            <div className="add-qr-form">
              <h3>Add Product Details</h3>

              <div className="form-inputs">

                {/* License Key */}
                <div>
                  <label>License Key</label>
                  <div className="sections">
                    <input
                      type="text"
                      className={`form-control ${fieldErrors.license ? "is-invalid" : ""}`}
                      value={license}
                      onChange={(e) => setLicense(e.target.value)}
                      placeholder="Enter License Key"
                      disabled={!!selectedProduct}
                    />
                    {!selectedProduct && (
                      <button onClick={checkLicense}>Validate</button>
                    )}
                  </div>
                  {fieldErrors.license && (
                    <div className="invalid-feedback d-block">{fieldErrors.license}</div>
                  )}
                </div>

                {selectedProduct && (
                  <>
                    {/* Product name */}
                    <div className="selected-product">
                      <label>Product Name: {selectedProduct.sku_name}</label>
                    </div>

                    {/* Product Image */}
                    <div>
                      <label>Product Image</label>
                      <input
                        type="file"
                        className={`form-control ${fieldErrors.productImage ? "is-invalid" : ""}`}
                        onChange={handleImageUpload}
                        accept="image/*"
                      />
                      {fieldErrors.productImage && (
                        <div className="invalid-feedback">{fieldErrors.productImage}</div>
                      )}
                    </div>

                    {/* GTIN */}
                    <div>
                      <label>Unique Product Identification Code (GTIN)</label>
                      <input
                        type="text"
                        inputMode="numeric"
                        pattern="\d{14}"
                        maxLength={14}
                        className={`form-control ${fieldErrors.gtin ? "is-invalid" : ""}`}
                        value={gtin}
                        onChange={handleGtinChange}
                        placeholder="Enter 14-digit GTIN"
                      />
                      {fieldErrors.gtin && (
                        <div className="invalid-feedback">{fieldErrors.gtin}</div>
                      )}
                    </div>

                    {/* Generic Name */}
                    <div>
                      <label>Generic Name of Drug</label>
                      <input
                        type="text"
                        className={`form-control ${fieldErrors.genericName ? "is-invalid" : ""}`}
                        value={genericName}
                        onChange={handleGenericName}
                        placeholder="Enter Generic Name"
                      />
                      {fieldErrors.genericName && (
                        <div className="invalid-feedback">{fieldErrors.genericName}</div>
                      )}
                    </div>

                    {/* Manufacturing Lic */}
                    <div>
                      <label>Manufacturing Lic. No.</label>
                      <input
                        type="text"
                        className={`form-control ${fieldErrors.manufacturingLic ? "is-invalid" : ""}`}
                        value={manufacturingLic}
                        onChange={handleManufacturingLicChange}
                        placeholder="Enter Manufacturing License Number"
                      />
                      {fieldErrors.manufacturingLic && (
                        <div className="invalid-feedback">{fieldErrors.manufacturingLic}</div>
                      )}
                    </div>

                    {/* Production Unit */}
                    <div>
                      <label>Production Unit</label>
                      <select
                        className={`form-control ${fieldErrors.groupId ? "is-invalid" : ""}`}
                        value={groupId}
                        onChange={(e) => setGroupId(e.target.value)}
                      >
                        <option value={JSON.stringify({})}>Select production unit</option>
                        {groupIds.map((id) => (
                          <option key={id.name} value={JSON.stringify(id)}>{id.name}</option>
                        ))}
                      </select>
                      {JSON.parse(groupId).addr && <label><b>Address:</b> {JSON.parse(groupId).addr}</label> }
                      {fieldErrors.groupId && (
                        <div className="invalid-feedback">{fieldErrors.groupId}</div>
                      )}
                    </div>

                    {/* Excipients */}
                    <div>
                      <label>List of Excipients</label>
                      <textarea
                        className={`form-control ${fieldErrors.excipients ? "is-invalid" : ""}`}
                        value={excipients}
                        onChange={handleExcipientsChange}
                      ></textarea>
                      {fieldErrors.excipients && (
                        <div className="invalid-feedback">{fieldErrors.excipients}</div>
                      )}
                    </div>

                    {/* Visit Us URL */}
                    <div>
                      <label>Visit Us URL</label>
                      <input
                        type="text"
                        className={`form-control ${fieldErrors.visitUsUrl ? "is-invalid" : ""}`}
                        value={visitUsUrl}
                        onChange={handleVisitUsUrlChange}
                        placeholder="Enter Visit Us URL"
                      />
                      {fieldErrors.visitUsUrl && (
                        <div className="invalid-feedback">{fieldErrors.visitUsUrl}</div>
                      )}
                    </div>
                  </>
                )}
              </div>

              {/* Submit / Cancel */}
              {selectedProduct && (
                <div className="sections">
                  <button className="generate-qr-button cancel" onClick={() => navigate('/dashboard')}>
                    Cancel
                  </button>
                  <button className="generate-qr-button" onClick={handleAddSKU}>
                    Add Product
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* ── No Units Message ── */}
      {showNoUnitsMessage && (
        <div className="no-units-message">
          No production units added. Please add them before adding product details.
        </div>
      )}

      {/* ── Confirmation Modal ── */}
      {alertMessage && (
        <div style={modalOverlayStyle}>
          <div style={modalBoxStyle}>

            {/* Header */}
            <div style={modalHeaderStyle}>
              <div style={{ fontFamily: "'Cormorant Garamond', Georgia, serif", fontSize: '1.3rem', fontWeight: 600 }}>
                Confirm and Validate Product Details
              </div>
              <div style={{ fontSize: '12px', opacity: 0.7, marginTop: '4px', fontFamily: "'Source Sans 3', system-ui, sans-serif" }}>
                Please read carefully before proceeding
              </div>
            </div>

            {/* Body */}
            <div style={modalBodyStyle}>
              <div style={warnBlockStyle}>
                <div style={{ fontSize: '13px', fontWeight: 700, color: '#b45309', marginBottom: '6px', fontFamily: "'Source Sans 3', system-ui, sans-serif" }}>
                  24-Hour Edit Window
                </div>
                <div style={{ fontSize: '13px', color: '#78350f', lineHeight: '1.6', fontFamily: "'Source Sans 3', system-ui, sans-serif" }}>
                  Once submitted, you will have <strong>24 hours</strong> to edit these product details.
                  After that, the data will be <strong>permanently locked</strong> and cannot be modified.
                </div>
              </div>

              <div style={ackBlockStyle}>
                By clicking <strong>Confirm and Validate</strong>, you acknowledge that all entered
                details are correct and that edits will only be possible within 24 hours of submission.
              </div>
            </div>

            {/* Footer */}
            <div style={modalFooterStyle}>
              <button style={btnBackStyle} onClick={() => setAlertMessage(false)}>
                Go Back and Review
              </button>
              <button style={btnConfirmStyle} onClick={SubmitDetails}>
                Confirm and Validate
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Loading ── */}
      <div className="loading" id="loading" hidden>
        <GridLoader color="var(--c-navy)" loading={true} size={18} />
      </div>
    </div>
  );
}

export default SKUDetails;